/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Claim_InvalidInputs */

const en_error_claim_invalid = /** @type {(inputs: Error_Claim_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The claim cannot be sent as it is.`)
};

/**
* | output |
* | --- |
* | "The claim cannot be sent as it is." |
*
* @param {Error_Claim_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_claim_invalid = /** @type {((inputs?: Error_Claim_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Claim_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_claim_invalid(inputs)
});